<template>
  <label ref="wrapper" :class="className" tabindex="-1" aria-live="polite">
      <input 
        ref="cbk"
        type="checkbox"
        :id="id"
        :name="name"
        :disabled="disabled"
        role="switch"
        :aria-checked="checked"
        :aria-label="getAriaLabel"
        :aria-labelledby="ariaLabelledby"
        :aria-describedby="ariaDescribedby"
        @change="toggle"
        @focus="focused = true"
        @blur="focused = false"
        v-model="checked"
     >
      <span
        class="c-switch-input--core"
        :style="coreStyle"
      >
        <span
          class="c-switch-input--button"
          :style="buttonStyle"
        />
      </span>
      <template v-if="showLabels">
        <span
          class="c-switch-input--label v-left"
          :style="labelStyle"
          v-if="checked"
        >{{onText}}
        </span>
        <span
          class="c-switch-input--label v-right"
          :style="labelStyle"
          v-else
        >{{offText}}</span>
      </template>
  </label>
</template>

<script>
import inputEventBus from '@/mixins/input-eventbus';
import { isString, isObject, isBoolean, has, get, translate, px } from '../utils/aha-utils'
import { isEmpty } from 'lodash'

export default {
  name: 'SwitchInput',
  props: {
    isChecked: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: true
    },
    toggleFor: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showLabels: {
      type: Boolean,
      default: true,
    },
    ariaLabel: {
      type: [String],
    },    
    ariaLabelledby: {
      type: [String],
    },
    ariaDescribedby: {
      type: [String],
    },
    onText: {
      type: String,
      default: 'on',
    },
    offText: {
      type: String,
      default: 'off',
    }
  },
  data () {
    return {
      checked: !!this.isChecked,
      lineHeight: 12,
      height: 22,
      width: 50,
      margin: 3,
      fontSize: 16,
      containerStyles: {},
      focused: false
    }
  },
  mounted () {
    const s = this.$refs["wrapper"];
    const styles = window.getComputedStyle(s,null);
    const lineHeight = styles.getPropertyValue('line-height');
    this.containerStyles = styles;
    this.fontSize = parseInt(styles.getPropertyValue('line-height')) * .8
    this.height = parseInt(styles.getPropertyValue('line-height')) + (this.margin * 2);
    this.emitToggleFor();
  },
  methods: {
    toggle(event) {
      const cbk = this.$refs["cbk"];
      cbk.value = this.checked;

      this.$emit('input', this.checked);
      this.$emit('change', {
        value: this.checked,
        name: this.name,
        srcEvent: event,
      });
      this.emitToggleFor(event);
    },
    emitToggleFor(event) {
      const cbk = this.$refs["cbk"];

      if(_.isString(this.toggleFor)) {
        const eventName = `toggle-for:${this.toggleFor}`;
        inputEventBus.$emit(`toggle-for:${this.toggleFor}`, this.checked, cbk, event);
      }
    }
  },
  computed: {
    className () {
      let { checked, disabled, focused } = this

      return ['c-switch-input', {
        checked,
        disabled,
        focused
      }]
    },
    ariaChecked() { return this.checked; },
    getAriaLabel() { return this.ariaLabelledby ? false : this.ariaLabel },
    coreStyle () {
      return {
        width: px(this.width),
        height: px(this.height),
        borderRadius: px(Math.round(this.height / 2))
      }
    },
    buttonRadius () {
      return this.height - this.margin * 2;
    },
    distance () {
      return px(this.width - this.height + this.margin)
    },
    buttonStyle () {
      const transition = `transform 300ms`
      const margin = px(this.margin)

      const transform = this.checked
        ? translate(this.distance, margin)
        : translate(margin, margin)

      return {
        width: px(this.buttonRadius),
        height: px(this.buttonRadius),
        transition,
        transform,
      }
    },
    labelStyle () {
      return {
        lineHeight: px(this.height),
        fontSize: this.fontSize ? px(this.fontSize) : null
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/sass/base";
  .c-switch-input {
    display: inline-block;
    position: relative;
    vertical-align: middle;
    font-size: 10px;
    cursor: pointer;

    &.focused {
      outline: -webkit-focus-ring-color auto 5px;
      outline-color: -webkit-focus-ring-color;
      outline-style: auto;
      outline-width: 5px;
    }

    input {
        opacity: 0;
        position: absolute;
        width: 1px;
        height: 1px;
    }

    &--label {
        position: absolute;
        top: 0;
        font-weight: 600;
        color: white;
        z-index: 1;

        &.v-left {
            left: 10px;
        }

        &.v-right {
            right: 10px;
        }
    }

    &--core {
        display: block;
        position: relative;
        box-sizing: border-box;

        outline: 0;
        margin: 0;

        transition: border-color .3s, background-color .3s;
        user-select: none;
        background-color: $dark;

        .checked & {
            background-color: $red;
        }

        
    }
    &--button {
        display: block;
        position: absolute;
        overflow: hidden;

        top: 0;
        left: 0;

        border-radius: 100%;
        background-color: #fff;
        z-index: 2;
    }
    &.disabled {
        pointer-events: none;
        opacity: 0.6;
    }
}

  legend.c-switch-input-legend {
    display: inline;
    margin-right: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/app/components/aha-switch-input.vue